export default __webpack_public_path__ + "static/Крысиные бега_16-31673a75e7520c540f80a10d8d519d66.jpg";